import {Howl} from 'howler'

const newOrderSound = new Howl({
    src: ['/sounds/queue_new_order.ogg']
});

function playNewOrder() {
    newOrderSound.play();
}

export default {
    playNewOrder
}